import { defineMessages } from 'react-intl';

export const messages: {
	planCardVersion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	planCardCompletion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openCardLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeCardLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	planCardVersion: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.plan-card-version',
		defaultMessage: 'Plan v{solutionVersion}',
		description: 'Plan card version (displayed in the header)',
	},
	planCardCompletion: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.plan-card-completion',
		defaultMessage: '{completion}% completion',
		description: 'Plan card build completion percentage (displayed in the header)',
	},
	openCardLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.open-card-label',
		defaultMessage: 'Open',
		description: 'Open card label for icon button (a11y purposes only)',
	},
	closeCardLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.close-card-label',
		defaultMessage: 'Close',
		description: 'Close card label for icon button (a11y purposes only)',
	},
});
